import { put, takeLatest, delay } from 'redux-saga/effects';
import {
  GET_MAILBOX_EMAILS,
  GET_MAILBOX_EMAILS_ERROR,
  SET_MAILBOX_EMAILS,
  SET_MAILBOX_DOCUMENTS,
  GET_MAILBOX_DOCUMENTS,
  GET_MAILBOX_DOCUMENTS_ERROR,
  SET_MAILBOX_REQUESTS,
  GET_MAILBOX_REQUESTS,
  GET_MAILBOX_REQUESTS_ERROR,
  SET_MAILBOX_SMS,
  GET_MAILBOX_SMS,
  GET_MAILBOX_SMS_ERROR,
  SET_MAILBOX_ALL,
  GET_MAILBOX_ALL,
  GET_MAILBOX_ALL_ERROR,
  GET_MAILBOX_LETTERS,
  GET_MAILBOX_LETTERS_ERROR,
  SET_MAILBOX_LETTERS,
  GET_MAILBOX_REPORTS,
  GET_MAILBOX_REPORTS_ERROR,
  SET_MAILBOX_REPORTS,
  SET_MAILBOX_REPORTS_SUBSCRIPTION,
  SET_MAILBOX_REPORTS_SUBSCRIPTION_USER,
  SET_MAILBOX_REPORTS_SUBSCRIPTION_ERROR,
} from '../redux/action/types';
import { areaApi } from '../utils/api';

function* getMailboxEmails() {
  try {
    const emails = yield areaApi.getMailboxEmails();
    yield put({
      type: SET_MAILBOX_EMAILS,
      data: emails.data,
    });
  } catch (err) {
    console.log(err);
    yield put({
      type: GET_MAILBOX_EMAILS_ERROR,
    });
  }
}

function* getMailboxSms() {
  try {
    const sms = yield areaApi.getMailboxSms();
    yield put({
      type: SET_MAILBOX_SMS,
      data: sms.data,
    });
  } catch (err) {
    console.log(err);
    yield put({
      type: GET_MAILBOX_SMS_ERROR,
    });
  }
}

function* getMailboxAll() {
  try {
    const all = yield areaApi.getMailboxAll();
    yield put({
      type: SET_MAILBOX_ALL,
      data: all.data,
    });
  } catch (err) {
    console.log(err);
    yield put({
      type: GET_MAILBOX_ALL_ERROR,
    });
  }
}

function* getMailboxDocuments() {
  try {
    const documents = yield areaApi.getMailboxDocuments();
    yield put({
      type: SET_MAILBOX_DOCUMENTS,
      data: documents.data,
    });
  } catch (err) {
    console.log(err);
    yield put({
      type: GET_MAILBOX_DOCUMENTS_ERROR,
    });
  }
}

function* getMailboxRequests() {
  try {
    const requests = yield areaApi.getMailboxRequests();
    yield put({
      type: SET_MAILBOX_REQUESTS,
      data: requests.data,
    });
  } catch (err) {
    console.log(err);
    yield put({
      type: GET_MAILBOX_REQUESTS_ERROR,
    });
  }
}

function* getMailboxLetters() {
  try {
    const requests = yield areaApi.getMailboxLetters();
    yield put({
      type: SET_MAILBOX_LETTERS,
      data: requests.data,
    });
  } catch (err) {
    console.log(err);
    yield put({
      type: GET_MAILBOX_LETTERS_ERROR,
    });
  }
}

function* getMailboxReports() {
  try {
    const requests = yield areaApi.getMailboxReports();
    yield put({
      type: SET_MAILBOX_REPORTS,
      payload: requests.data,
    });
  } catch (error) {
    console.log('getMailboxReports', error);
    yield put({
      type: GET_MAILBOX_REPORTS_ERROR,
    });
  }
}

function* setReportsSubscription({ payload }) {
  try {
    yield areaApi.setMailboxReportsSubscription(payload);
    yield delay(500);
    yield put({
      type: SET_MAILBOX_REPORTS_SUBSCRIPTION_USER,
      payload: payload,
    });
  } catch (error) {
    console.log('setReportsSubscription', error);
    yield put({
      type: SET_MAILBOX_REPORTS_SUBSCRIPTION_ERROR,
    });
  }
}

function* mailboxSaga() {
  yield takeLatest(GET_MAILBOX_REQUESTS, getMailboxRequests);
  yield takeLatest(GET_MAILBOX_EMAILS, getMailboxEmails);
  yield takeLatest(GET_MAILBOX_DOCUMENTS, getMailboxDocuments);
  yield takeLatest(GET_MAILBOX_SMS, getMailboxSms);
  yield takeLatest(GET_MAILBOX_LETTERS, getMailboxLetters);
  yield takeLatest(GET_MAILBOX_ALL, getMailboxAll);
  yield takeLatest(GET_MAILBOX_REPORTS, getMailboxReports);
  yield takeLatest(SET_MAILBOX_REPORTS_SUBSCRIPTION, setReportsSubscription);
}

export default mailboxSaga;
